module.exports = __webpack_public_path__ + "img/ide.8086f158.png";